import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportCardPdfService {
  requestUrl: string;

  constructor(private http: HttpClient) { }

  getReportCardPdf(businessId: string, year: string) {
    let baseURL = '';
    if (environment.name === 'prod') {
      baseURL = 'https://www.aopa.org/';
    } else {
      baseURL = 'https://webappstage.aopa.org/';
    }
    this.requestUrl = baseURL + `customerfeedbackreports/${year}/${businessId}_${year}FlightSchoolReport.pdf`;
    return this.http.get(this.requestUrl, {responseType: 'blob', observe: 'response'}).pipe(
      map((res: any) => {
        return new Blob([res.body], {type: 'application/pdf'});
      })
    );
  }
}
